/**
 * SugerirMejoraHost — escucha el evento del speed dial y abre el modal.
 *
 * Mismo patrón que el teléfono (`sf:open-dialer` → FloatingDialerWidget): el
 * speed dial no conoce el modal ni sus dependencias, solo emite un evento. Así
 * el modal —que trae Polaris, Supabase y el contexto de sesión— no entra en el
 * árbol de un componente que se pinta en todas las pantallas.
 */
import { useCallback, useEffect, useState } from 'react';
import { SugerirMejoraModal } from './SugerirMejoraModal';
import { EVENTO_SUGERIR_MEJORA } from './eventos';

export function SugerirMejoraHost() {
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    const abrir = () => setAbierto(true);
    window.addEventListener(EVENTO_SUGERIR_MEJORA, abrir);
    return () => window.removeEventListener(EVENTO_SUGERIR_MEJORA, abrir);
  }, []);

  const cerrar = useCallback(() => setAbierto(false), []);

  // Hasta que alguien lo pide, no se monta nada: el modal no existe en el DOM
  // ni pesa en el arranque del panel.
  if (!abierto) return null;

  return <SugerirMejoraModal open={abierto} onClose={cerrar} />;
}
